import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET
};

let firebaseApp;
let db;
let auth;

export const init = () => {
  const firebaseApp = initializeApp(firebaseConfig);
  if(!db) {
    db = getFirestore(firebaseApp);
  }
  if(!auth) {
    auth = getAuth(firebaseApp);
  }
};
init();

export const exportDbAccess = () => {
  return db;
};

export const exportStorageAccess = () => {
  return getStorage(firebaseApp);
};

export { auth };